// src/modules/public/components/RulesView/index.js
import React from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import './styles.css';

const RulesView = () => {
    return (
        <div className="rules-container">
            <Card>
                <Card.Header>
                    <h3>Competition Rules</h3>
                </Card.Header>
                <Card.Body>
                    <h4>General Rules</h4>
                    <p>
                        Welcome to our fitness competition! This competition encourages
                        physical activity among team members through a point-based system.
                    </p>

                    <h5>Activity Requirements</h5>
                    <ListGroup className="mb-3">
                        <ListGroup.Item>
                            <strong>Running:</strong> Minimum 2km at pace of 9 min/km or faster
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <strong>Cycling:</strong> Minimum 10km at speed of 18 km/h or faster
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <strong>Swimming:</strong> Minimum 100 meters
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <strong>Hiking:</strong> Minimum 1.5km at pace of 20 min/km or faster
                        </ListGroup.Item>
                    </ListGroup>

                    <h5>Points Calculation</h5>
                    <ListGroup className="mb-3">
                        <ListGroup.Item>
                            <strong>Running:</strong> 1 point per km + 1 point per 100m elevation
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <strong>Cycling:</strong> 0.25 points per km + 1 point per 200m elevation
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <strong>Swimming:</strong> 4 points per km
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <strong>Hiking:</strong> 0.5 points per km + 0.5 points per 100m elevation
                        </ListGroup.Item>
                    </ListGroup>

                    <h5>Competition Mechanics</h5>
                    <ListGroup className="mb-3">
                        <ListGroup.Item>
                            Winner becomes "Minister of Activity" for next competition
                        </ListGroup.Item>
                        <ListGroup.Item>
                            Cake threshold set at 80% of winner's points
                        </ListGroup.Item>
                        <ListGroup.Item>
                            Last place provides cake to those above threshold
                        </ListGroup.Item>
                        <ListGroup.Item>
                            Minister of Activity is exempt from cake duty
                        </ListGroup.Item>
                    </ListGroup>

                    <div className="rules-note">
                        <strong>Note:</strong> All activities must be tracked using approved 
                        fitness apps (Strava, Google Fit, Samsung Health, Runkeeper, 
                        WorkOutDoors, or Garmin Connect).
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default RulesView;
